<div class="w-100 h-100 d-flex flex-column align-items-start wrapper animated fadeIn">
	<button data-test-id="btn-back" type="button" class="btn btn-back" (click)="close.emit()">Back</button>
	<!-- Title & export -->
	<div class="header w-100 d-flex align-items-center justify-content-between">
		<h2 class="title mb-0" data-test-id="title">Existing RIs & SPs</h2>
		<app-button-icon
			data-test-id="btn-export"
			tooltipText="Export"
			placement="top"
			[disabled]="!productLabel && !exportData.length"
			[isSecondary]="true"
			(click)="export()"
		>
			<i class="fas fa-download"></i>
		</app-button-icon>
	</div>
	<div class="table-wrapper d-flex flex-column w-100">
		<!-- Filters -->
		<app-commitment-filters class="mb-2" [apiGridFilters]="apiGridFilters"></app-commitment-filters>
		<!-- Grid -->
		<app-state-switcher
			data-test-id="existingRiSpTable"
			class="flex-grow-1 overflow-auto"
			[state]="apiGrid.stateChanges() | async"
		>
			<app-grid
				*ngIf="(apiGrid.changes() | async)?.items as commitments"
				[uniqKey]="'rowId'"
				[listAdapter]="apiGrid"
				[isStickyHeader]="true"
				[type]="gridType"
				[customRowClassesFn]="customRowClassesFn"
				[columns]="commitmentColumns"
			>
				<div
					*appCustomCell="commitmentTableCells.type; let commitment = row; let type = value"
					class="ri-sp-label"
					[class.expired]="commitment.isExpired"
				>
					<span>{{ type | uppercase }}</span>
				</div>
				<div
					*appCustomCell="commitmentTableCells.isZestySupported; let commitment = row; let isZestySupported = value"
					class="text-center"
				>
					<span *ngIf="isZestySupported; else notSupportedBadge">
						<img
							ngSrc="/assets/icons/potential-savings/zesty-commitment-supported.svg"
							alt="Supported"
							height="14"
							width="11"
						/>
					</span>

					<ng-template #notSupportedBadge>
						<span [appInfoTooltip]="commitment.zestyNotSupportedReason">
							<img
								ngSrc="/assets/icons/potential-savings/zesty-commitment-unsupported.svg"
								alt="Unsupported"
								height="14"
								width="11"
							/>
						</span>
					</ng-template>
				</div>
				<div *appCustomCell="commitmentTableCells.start; let start = value">
					<span>{{ start | shortDate }}</span>
				</div>
				<div
					*appCustomCell="commitmentTableCells.end; let commitment = row; let end = value"
					class="d-flex align-items-center"
					[class.end-date-expired]="commitment.isExpired"
				>
					<i class="icon-clock mr-1"></i>
					<span>{{ end | shortDate }}</span>
				</div>
				<div *appCustomCell="commitmentTableCells.hourlyCommitment; let hourlyCommitment = value">
					${{ hourlyCommitment | longNumber }}/h
				</div>
				<div *appCustomCell="commitmentTableCells.amortized; let amortized = value">
					${{ amortized | longNumber }}/mo
				</div>
				<div
					*appCustomCell="commitmentTableCells.utilizationPercentage; let utilizationPercentage = value"
					[class.low-utilization]="utilizationPercentage < 1"
				>
					{{ utilizationPercentage | percent }}
				</div>
				<div *appCustomCell="commitmentTableCells.savingsPercentage; let savingsPercentage = value">
					{{ savingsPercentage | percent }}
				</div>
				<div *appCustomCell="commitmentTableCells.headerSavings; let column = column" class="d-flex align-items-center">
					<app-sort-header [column]="column" [filter]="apiGrid.filters">
						<div *appCustomHeader class="d-flex align-items-center">
							<span>{{ column.name }}</span>
							<i
								appInfoTooltip="The savings achieved by existing commitment, taking utilization into account."
								class="fas fa-info-circle cursor-link ml-1"
							></i>
						</div>
					</app-sort-header>
				</div>
				<div *appCustomCell="commitmentTableCells.savings; let savings = value">${{ savings | longNumber }}</div>
				<!-- Total row -->
				<tr
					*appCustomRow="insertCustomRowAtIndexFn"
					app-commitment-total-row
					[commitmentTotal]="commitmentTotal$ | async"
				></tr>
			</app-grid>

			<div *appEmptyState class="no-data">
				<span>No commitments to display</span>
			</div>
		</app-state-switcher>
	</div>
</div>
